import React, { useEffect, useRef } from 'react'

/**
 * AudioPlayer component is a simple audio player that allows users to play audio files from a given source URL.
 * @param {string} src - The source URL of the audio file to play.
 * @param {string} className - Additional class names for styling.
 * @param {boolean} reloadWidthFix - Whether to force a repaint when the audio is loaded. This is a workaround for a visual bug in some browsers.
 */
export const AudioPlayer: React.FC<{ src: string; className?: string; reloadWidthFix?: boolean }> = ({
  src,
  className,
  reloadWidthFix,
}) => {
  const [isLoaded, setIsLoaded] = React.useState(false)
  const audioRef = useRef<HTMLAudioElement>(null)

  // BUG FIX
  // Trigger a small width change to force a repaint when the audio is loaded
  useEffect(() => {
    if (isLoaded && audioRef.current && reloadWidthFix) {
      const audio = audioRef.current
      // one possible fix
      audio.removeAttribute('controls')
      audio.setAttribute('controls', '')
      // another possible fix
      audio.style.width = '99.9%'
      setTimeout(() => {
        audio.style.width = '99.8%'
      }, 10)
      setTimeout(() => {
        audio.style.width = ''
      }, 100)
    }
  }, [isLoaded])

  return (
    <audio
      ref={audioRef}
      src={src}
      className={`flex ${className}`}
      controls
      preload="metadata"
      onLoadedMetadata={() => setIsLoaded(true)}
    />
  )
}
